import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DatosPeriodoViewModel, ListaPlazosPeriodoCamViewModel, PlazoPeriodoCamViewModel } from './plazos.types';

@Injectable()
export class PeriodoPlazoService {
    endpoint = this.baseUrl + 'api/mantenimiento/periodos/plazos/';
    private _plazoPeriodo: PlazoPeriodoCamViewModel;
    private _datosPeriodo: DatosPeriodoViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Invokes the service to get the PlazoPeriodo, applying the filter in the parameter
     * @param payload IdPeriodo number
     * @returns PlazoPeriodoCamViewModel
     */
    getPlazoPeriodo(idPeriodo: number): Observable<PlazoPeriodoCamViewModel> {
        return this.http.get<PlazoPeriodoCamViewModel>(this.endpoint + idPeriodo);
    }

    getListaPlazosDePeriodo(idPeriodo: number): Observable<ListaPlazosPeriodoCamViewModel> {
        return this.http.get<ListaPlazosPeriodoCamViewModel>(this.endpoint + 'ListaPlazos/' + idPeriodo);
    }

    getDatosPeriodo(idPeriodo: number): Observable<DatosPeriodoViewModel> {
        return this.http.get<DatosPeriodoViewModel>(this.endpoint + 'DatosPeriodo/' + idPeriodo);
    }

    getEsObligatoriaPrimeraInspeccion(idPeriodo: number): Observable<boolean> {
        return this.http.get<boolean>(this.endpoint + 'esObligatoriaPrimeraInspeccion/' + idPeriodo);
    }

    get plazoPeriodo(): PlazoPeriodoCamViewModel {
        return this._plazoPeriodo;
    }

    set plazoPeriodo(plazoPeriodo: PlazoPeriodoCamViewModel) {
        this._plazoPeriodo = plazoPeriodo;
    }

    get datosPeriodo(): DatosPeriodoViewModel {
        return this._datosPeriodo;
    }

    set datosPeriodo(datosPeriodo: DatosPeriodoViewModel) {
        this._datosPeriodo = datosPeriodo;
    }

    save(payload: PlazoPeriodoCamViewModel): Observable<any> {
        // delete model.Descripcion;  // Para forzar un fallo en el backend y ver que pasa en el catchError
        if (payload?.Id) {
            return this.edit(payload);
        }
        return this.create(payload);
    }

    private create(payload: PlazoPeriodoCamViewModel): Observable<any> {
        return this.http.post<PlazoPeriodoCamViewModel>(this.endpoint, payload);
    }

    private edit(payload: PlazoPeriodoCamViewModel): Observable<any> {
        return this.http.put<PlazoPeriodoCamViewModel>(this.endpoint, payload);
    }

    delete(id: number): Observable<any> {
        return this.http.delete<PlazoPeriodoCamViewModel>(this.endpoint + id).pipe();
    }
}
